export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_04.dbea93fe.png";